import React, { useRef, useEffect } from 'react';
import {
  ModalButtonRow,
  ModalCard,
  ModalCloseButton,
  ModalOverlay,
  AskAICtaPrimaryButton,
  AskAICtaSecondaryButton,
} from '../AskAIPageStyles';
import { decodeHTML } from '../../../utility/utils.js';

const LangSwitchModal = ({
  showLangSwitchModal,
  setShowLangSwitchModal,
  handleLangSwitchConfirm,
   askAiData
}) => {
   const modalRef = useRef(null);
  const closeButtonRef = useRef(null);

  const closeModal = () => {
    setShowLangSwitchModal(false);
  };

  useEffect(() => {
    if (!showLangSwitchModal) return;


      // --- NEW CODE: Capture trigger and calculate next element ---
    const triggerElement = document.activeElement;
    let nextElementFallback = null;

    if (triggerElement) {
      const allFocusableElements = Array.from(
        document.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      );
      const triggerIndex = allFocusableElements.indexOf(triggerElement);
      
      if (triggerIndex !== -1 && triggerIndex + 1 < allFocusableElements.length) {
        nextElementFallback = allFocusableElements[triggerIndex + 1];
      }
    }
    // -----------------------------------------------------------
    // Focus the close button when the modal opens
    const rafId = window.requestAnimationFrame(() => {
      closeButtonRef.current?.focus();
    });

    const handleKeyDown = (event) => {
      // Close on Escape key
      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal();
        return;
      }
      
      // Focus lock/trap inside the modal on Tab key
      if (event.key !== 'Tab' || !modalRef.current) return;

      const focusables = modalRef.current.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );

      if (!focusables.length) {
        event.preventDefault();
        return;
      }

      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      const active = document.activeElement;

      if (event.shiftKey && active === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && active === last) {
        event.preventDefault();
        first.focus();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      window.cancelAnimationFrame(rafId);
      document.removeEventListener('keydown', handleKeyDown);

       if (triggerElement && document.body.contains(triggerElement)) {
        triggerElement.focus();
      } else if (nextElementFallback && document.body.contains(nextElementFallback)) {
        nextElementFallback.focus();
      }
    };
  }, [showLangSwitchModal, setShowLangSwitchModal]);

  if (!showLangSwitchModal) return null;

  return (
    <ModalOverlay onClick={closeModal}>
      <ModalCard onClick={(e) => e.stopPropagation()} 
      ref={modalRef} 
      role="dialog"
        aria-modal="true"
        aria-labelledby="lang-switch-modal-title"
        aria-describedby="lang-switch-modal-description">
        <ModalCloseButton
          type='button'
          onClick={closeModal}
          aria-label='Close'
           ref={closeButtonRef}
        >
          <svg
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M1 1L15 15M15 1L1 15'
              stroke='black'
              strokeWidth='1.5'
              strokeLinecap='round'
            />
          </svg>
        </ModalCloseButton>
        <h2 className='vds-title-lg mobile-vds-title-md font-eDS-bold' id="lang-switch-modal-title">
          {decodeHTML(askAiData?.resultsPageTexts?.esModalTexts?.swtchEsLveAskAi)}
        </h2>
        <div className='vds-body-lg mt-8X sm-mt-6X'  id="lang-switch-modal-description">
          {decodeHTML(askAiData?.resultsPageTexts?.esModalTexts?.swtchEsChatEndText)}
        </div>
        <ModalButtonRow>
          <AskAICtaPrimaryButton type='button' onClick={handleLangSwitchConfirm}>
            <span className='vds-body-lg font-eDS-bold'> {askAiData?.resultsPageTexts?.esModalTexts?.swtchLngBtnText}</span>
          </AskAICtaPrimaryButton>
          <AskAICtaSecondaryButton
            type='button'
            onClick={closeModal}
          >
            <span className='vds-body-lg font-eDS-bold'>{askAiData?.resultsPageTexts?.esModalTexts?.cnclButtonText}</span>
          </AskAICtaSecondaryButton>
        </ModalButtonRow>
      </ModalCard>
    </ModalOverlay>
  );
};

export default LangSwitchModal;